










































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { BreakdownSummaryTotals } from "@/views/Investor/Summary.vue";
import { AdcontrolProfile } from "@/models";
import { Getter } from "vuex-class";

@Component
export default class BreakdownTotal extends Vue {
  @Prop() readonly value!: BreakdownSummaryTotals;
  @Prop({ required: true }) readonly entryId!: string;
  @Prop({ required: true }) readonly type!: string;
  @Prop({ default: true }) readonly loading?: boolean;
  @Prop({ default: false }) readonly showGrp!: boolean;
  @Prop({
    default: () => {
      return { tv: false, radio: false };
    },
  })
  readonly mediaType!: { tv: boolean; radio: boolean };
  @Getter("profile")
  readonly profile!: AdcontrolProfile;

  get hideNonVodIfProfileVodOnly(): boolean {
    if (this.profile?.mediaSourceKind == "msk_vod") {
      return true;
    }
    return false;
  }

  get classCreativityLocked() {
    return this.value.creativities > 0 ? "" : "breakdown-total__item--locked";
  }

  get grpValue() {
    return this.value.grp;
  }

  get broadcasterLabel(): string {
    if (this.mediaType.tv && !this.mediaType.radio) {
      return "Canali TV";
    }
    if (this.mediaType.radio && !this.mediaType.tv) {
      return "Canali radio";
    }
    return "Canali TV e radio";
  }

  get showEbiquity() {
    return (
      this.mediaType.radio &&
      !this.mediaType.tv &&
      this.value.ebiquityMin > 0 &&
      this.value.ebiquityMax > 0
    );
  }
}
